// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"730f32c0","496":"6063a208","559":"c5c15cba"}[chunkId] + ".chunk.js";
};